<template>
  <div class="main-container">
    <h1 v-if="showReady">{{ getMessage('TTL_LISTO') }}</h1>
    <h1>{{ message }}</h1>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    message: {
      type: String
    },
    showReady: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters('GeneralAR', ['getMessage'])
  },
  data () {
    return {}
  },
  mounted: function () {
    this.showMessageAndExit()
  },
  methods: {
    showMessageAndExit: function () {
      var vm = this
      setTimeout(function () {
        vm.$router.push({ name: 'TotemHome' })
      }, 15000)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
</style>
